import { Search, X } from 'lucide-react';
import { useMemo, useState } from 'react';
import type { Series } from '../types';

interface SearchOverlayProps {
  series: Series[];
  onClose: () => void;
  onOpenSeries: (series: Series) => void;
}

export function SearchOverlay({ series, onClose, onOpenSeries }: SearchOverlayProps) {
  const [query, setQuery] = useState('');
  const results = useMemo(() => {
    const normalized = query.trim().toLowerCase();
    if (!normalized) return series;
    return series.filter((item) =>
      `${item.title} ${item.genres.join(' ')} ${item.description}`.toLowerCase().includes(normalized)
    );
  }, [query, series]);

  return (
    <div className="search-overlay" role="dialog" aria-modal="true" aria-label="Search catalogue">
      <div className="search-topbar">
        <div className="search-input-wrap">
          <Search />
          <input autoFocus value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search titles, genres and stories" />
        </div>
        <button className="icon-button" onClick={onClose} aria-label="Close search"><X /></button>
      </div>
      <div className="search-results">
        <p>{results.length} result{results.length === 1 ? '' : 's'}</p>
        <div className="search-grid">
          {results.map((item) => (
            <button key={item.id} className="search-result-card" onClick={() => onOpenSeries(item)}>
              <img src={item.cardImage} alt="" />
              <span><strong>{item.title}</strong><small>{item.genres.join(' • ')}</small></span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
